import { sortBarGetters } from './routines'

export default {
  [sortBarGetters.SORT_BY_LOAN_AMOUNT]: state => state.sortByLoanAmount,
  [sortBarGetters.SORT_BY_GRANT_AMOUNT]: state => state.sortByGrantAmount,
  [sortBarGetters.SORT_BY_INTEREST_RATE]: state => state.sortByInterestRate,
  [sortBarGetters.SORT_BY_DECISION_TIME]: state => state.sortByDecisionTime,
  [sortBarGetters.SORT_BY_PRODUCT_TYPE]: state => state.sortByProductType
}
